import { HttpStatusCode } from '@shared/types';

export default defineNuxtPlugin(() => {
  const headers = useRequestHeaders(['cookie']);
  const api = $fetch.create({
    baseURL: useRuntimeConfig().public.apiUrl,
    credentials: 'include',
    headers,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async onResponseError({ response }: any) {
      const statusMessage = response?.status === HttpStatusCode.UNAUTHORIZED ? 'Unauthorized' : 'Response failed';

      console.error('onResponseError ', {
        endpoint: response.url,
        status: response?.status,
        statusMessage,
      });
    },
  });
  return {
    provide: {
      api,
    },
  };
});
